import { render, staticRenderFns } from "./payment.vue?vue&type=template&id=dbddf492&scoped=true"
import script from "./payment.vue?vue&type=script&lang=js"
export * from "./payment.vue?vue&type=script&lang=js"
import style0 from "./payment.vue?vue&type=style&index=0&id=dbddf492&prod&lang=less&scoped=true"
import style1 from "./payment.vue?vue&type=style&index=1&id=dbddf492&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbddf492",
  null
  
)

export default component.exports